const SCHEDULE_VALIDITY_MODE = {
    NOT_APPLICABLE: 0,
    FIXED_DATE: 1,
    ACCORDING_TO_THE_INSCRIPTION: 2
}

export default {SCHEDULE_VALIDITY_MODE}

